import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';
import noop from "../../../../../core/modules/common/tools/noop";

// eslint-disable-next-line react/prefer-stateless-function
class Resdit7421PerformanceReport extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Report
        id={this.props.id}
        tabs={[
          {
            value: ReportDefinitions.RESDIT_74_21_PERFORMANCE_CARRIER_107B.id,
            label: 'Carrier',
          },
          {
            value: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id,
            label: 'Location',
            loadFromTable: true,
            loadFromTableMessage: 'app.warning.load.from.summary.report',
          },
          {
            value: ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_107B.id,
            label: 'Details',
            loadFromTable: true,
            loadFromTableMessage: 'app.warning.load.from.summary.report',
          },
        ]}
        {...this.props}
      />
    );
  }
}
export default Resdit7421PerformanceReport;

Resdit7421PerformanceReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  onSortedChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
};
Resdit7421PerformanceReport.defaultProps = {
  id: '',
  data: [],
  columns: [],
  generatedOnDateTime: '',
  isLoading: false,
  reportId: '',
  onSortedChange: noop,
  onFilteredChange: noop,
};
